import { TabList as TabListRaw, TabPanel as TabPanelRaw, Tab as TabRaw, Tabs as TabsRaw, } from 'react-tabs';
import { styled } from 'styled-components';
import THEME from '../theme.js';
const Tabs = styled(TabsRaw) ``;
const Tab = styled(TabRaw) `
  display: inline-block;
  position: relative;
  cursor: pointer;
  font-size: 0.9em;
  padding: 14px 8px 8px 8px;
  transition: padding 0.2s;
  user-select: none;

  &:last-child {
    border-right: none;
    padding-right: 0px;
  }

  &:first-child {
    padding-left: 0px;
  }

  &.react-tabs__tab--selected {
    font-weight: bold;
  }

  &.react-tabs__tab--selected::after,
  &:hover::after {
    content: '';
    left: 0;
    height: 3px;
    width: 100%;
    bottom: -3px;
    position: absolute;
  }

  &:hover::after {
    background-color: ${() => THEME.DARK_COLOR_SECONDARY};
  }

  &.react-tabs__tab--selected::after {
    background-color: ${() => THEME.COLOR_ACCENT};
  }
`;
// @ts-ignore
Tab.tabsRole = 'Tab';
const TabList = styled(TabListRaw) `
  padding: 10px 0 0 0;
  border-bottom: 3px solid ${THEME.BORDER_STRONG};
  margin: 0 0 ${THEME.GRID_SPACING}px 0 !important;
`;
// @ts-ignore
TabList.tabsRole = 'TabList';
const TabPanel = styled(TabPanelRaw) ``;
// @ts-ignore
TabPanel.tabsRole = 'TabPanel';
export { Tabs, Tab, TabList, TabPanel };
//# sourceMappingURL=Tabs.js.map